import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { SynopticLogoIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo.js';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import {
  homeCardLeftContainer,
  homeExploreButton,
  homeStreamPackagesCard,
  homeStreamPackagesDescription,
  homeStreamPackagesHeader,
  homeStreamPackagesImage,
  homeStreamPackagesImageContainer,
  homeStreamPackagesTitle,
  homeStreamPackagesHeaderText,
  homeGradientBlock,
} from './home-stream-packages-banner.css.ts';
import StreamPackagesImg from './stream-packages-banner.png';

export const HomeStreamPackagesBanner = () => {
  return (
    <div className={homeStreamPackagesCard}>
      <div className={homeCardLeftContainer}>
        <div className={homeStreamPackagesHeader}>
          <SynopticLogoIcon width={63} height={16} />
          <span className={homeStreamPackagesHeaderText}>recommends</span>
        </div>
        <div>
          <h4 className={homeStreamPackagesTitle}>
            Stream smarter: Unlock exclusive stream packages!
          </h4>
          <p className={homeStreamPackagesDescription}>
            Get more value with curated packages that bundle multiple
            high-quality streams at the best price. Access exclusive content
            from Synoptic or choose a cost-effective package to maximize your
            insights.
          </p>
        </div>
        <Button
          size={'small'}
          variant="secondary"
          className={homeExploreButton}
          asChild
        >
          <Link to={paths.streamPackages}>Explore packages</Link>
        </Button>
      </div>
      <div className={homeStreamPackagesImageContainer}>
        <img
          src={StreamPackagesImg}
          alt={'Stream packages banner'}
          className={homeStreamPackagesImage}
        />
        <div className={homeGradientBlock} />
      </div>
    </div>
  );
};
